import { useEasyServiceGetApiEasyCountry } from "../../../../openapi/api/queries/queries";
import { exportQuoteToExcel } from "../../tools/helper";

import { JSX } from "react";
import { useTranslation } from "react-i18next";

import { useLanguage } from "@4pace-cpq/core";
import Button from "@mui/material/Button";
import {
  useConfigurationApi,
  useSessionId,
} from "@plansoft-configuration-renderer/framework";

type Country = {
  string: string;
};

export function DownloadUserManualButton(): JSX.Element {
  const api = useConfigurationApi();
  const sessionId = useSessionId();
  const { selectedLanguage } = useLanguage();
  const { t } = useTranslation();

  const { data: countryData } = useEasyServiceGetApiEasyCountry();
  const country = countryData as Country;

  const language = selectedLanguage?.languageCode?.split("-")[0];

  async function fetchUserManual(): Promise<string> {
    const res = await api.invokeUserDefinedGetter({
      id: sessionId,
      name: "getMarketingCategory",
      invokeUserDefinedGetterParams: {
        path: "/XAS_PRODUCT_VIEW/0/",
        input: JSON.stringify({}),
      },
    });
    if (res?.output) {
      return res?.output;
    }
    return "";
  }

  async function handleDownload(): Promise<void> {
    const materialNumber = await fetchUserManual();
    exportQuoteToExcel(
      materialNumber,
      country.string ?? "AT",
      language ?? "EN",
      t,
    );
  }

  return (
    <Button onClick={handleDownload} variant="contained">
      {t("WEG:buttons.downloadUserManual")}
    </Button>
  );
}
